// top bar handling
window.addEventListener("scroll", function () {
  let scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
 
  
  let header = document.querySelector("header");
  if (header) {
    if (scrollPos > 100) {
      header.classList.add("show");
    } else {
      header.classList.remove("show");
    }
  }
});